import { render, staticRenderFns } from "./PainelTermosNaoResolvidos.vue?vue&type=template&id=087f5683&scoped=true"
import script from "./PainelTermosNaoResolvidos.vue?vue&type=script&lang=js"
export * from "./PainelTermosNaoResolvidos.vue?vue&type=script&lang=js"
import style0 from "./PainelTermosNaoResolvidos.vue?vue&type=style&index=0&id=087f5683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087f5683",
  null
  
)

export default component.exports